export default __webpack_public_path__ + "static/insect-based-dog-food-2-110716a9f4c815e88ee65b152b59442c.jpg";